import { render, staticRenderFns } from "./zqtys.vue?vue&type=template&id=6e067668"
import script from "./zqtys.vue?vue&type=script&lang=js"
export * from "./zqtys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports